import { render, staticRenderFns } from "./collisionDetail.vue?vue&type=template&id=30de27bc&scoped=true"
import script from "./collisionDetail.vue?vue&type=script&lang=js"
export * from "./collisionDetail.vue?vue&type=script&lang=js"
import style0 from "./collisionDetail.vue?vue&type=style&index=0&id=30de27bc&prod&lang=less"
import style1 from "./collisionDetail.vue?vue&type=style&index=1&id=30de27bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de27bc",
  null
  
)

export default component.exports